export const getSaveFlatRatesPayload = (values) => {
    return {
        enabled: values.pricingMethod === 'Fixed',
        domesticShippingBasePrice: { value: parseFloat(values.domesticFirst) || 0, currency: 'USD' },
        domesticShippingEachAdditionalItemFee: {
            value: parseFloat(values.domesticAdditional) || 0,
            currency: 'USD',
        },
        internationalShippingBasePrice: {
            value: parseFloat(values.internationalFirst) || 0,
            currency: 'USD',
        },
        internationalShippingEachAdditionalItemFee: {
            value: parseFloat(values.internationalAdditional) || 0,
            currency: 'USD',
        },
    };
};
